import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Img from "../../../images/podcast/ep-1.png";
import {LazyLoadImage} from "react-lazy-load-image-component";


function Banner(props) {
    return (

        <div className="services_banner ">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
                        <div className="example" data-text="Tek Podcast">
                            <h1>How Steve Built A Successful Business While Saving Lives Through The Veteran App</h1>
                        </div>
                        <div
                            className="banner_content_txt listing_flex">
                            <p>In episode #01, we sat with the founder of “The Veteran App” to discuss the role of technology in saving lives and creating positive impact in the world. We navigated through Steve’s entrepreneurial journey to decode the strategies that helped him overcome the many challenges he had to face, from finding working partners, pitching to investors,raising capital to kick start his journey as an entrepreneur and establish a successful business.</p>
                        </div>
                    </Col>
                    <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto text-center">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;